import { Outlet } from "react-router-dom";

export function ExploreLayout() {
  return <Outlet />;
}
